import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetTransaction  {
    _originalTypeClassName = "zERP.BO.AssetTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetTransaction.translate = translateService;
}
this.Items = [];
this.Documents = [];
this.Asset = new Domain.Asset();
this.SubsidyEntities = [];
this.GeneralJournals = [];
this.Id = null;
this.Description = null;
this.CreatedAt = null;
this.FinalizedAt = null;
this.IsFinalized = false;
this.Type = null;
this.DestructionType = null;
this.AcquisitionType = null;
this.ReferenceDate = null;
this.IsTotalDestructionOrSale = false;
this.PartialDestructionOrSaleQuantity = null;
this.AdjusmentAmount = null;
this.ImprovementValue = null;
this.AcquisitionQuantity = null;
this.AcquisitionValue = null;
this.AcquisitionSerialNumber = null;
this.TaxDepreciationOutcome = null;
this.AccountingDepreciationOutcome = null;
this.LostOwnershipTaxProfit = null;
this.LostOwnershipTaxLoss = null;
this.LostOwnershipAccountingProfit = null;
this.LostOwnershipAccountingLoss = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Description:any;
CreatedAt:any;
FinalizedAt:any;
IsFinalized:any;
Type:any;
DestructionType:any;
AcquisitionType:any;
ReferenceDate:any;
IsTotalDestructionOrSale:any;
PartialDestructionOrSaleQuantity:any;
AdjusmentAmount:any;
ImprovementValue:any;
AcquisitionQuantity:any;
AcquisitionValue:any;
AcquisitionSerialNumber:any;
TaxDepreciationOutcome:any;
AccountingDepreciationOutcome:any;
LostOwnershipTaxProfit:any;
LostOwnershipTaxLoss:any;
LostOwnershipAccountingProfit:any;
LostOwnershipAccountingLoss:any;
Items:any;
ERPFiscalYear:any;
Customer:any;
VATRate:any;
Documents:any;
Asset:any;
DestructionProtocol:any;
ParentAsset:any;
ExpropriationDocument:any;
SubsidyEntities:any;
GeneralJournals:any;
RelatedTransaction:any;
AcquisitionDepartment:any;
TradingLocation:any;
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.AssetTransaction.removeItems($this, $this.Items[0]);
                }

                Domain.AssetTransaction.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetTransaction.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
if (item.Transaction != $this) {
Domain.AssetTransactionItem.setTransaction(item, $this);
}
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetTransaction.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
item.Transaction = null;
}
static clearItems = ($this) => { $this.Items = null; }
static setERPFiscalYear = ($this, value) => {
var oldValue = $this.ERPFiscalYear;
$this.ERPFiscalYear = value;
if (value != null) {
}
}
static setCustomer = ($this, value) => {
var oldValue = $this.Customer;
$this.Customer = value;
if (value != null) {
}
}
static setVATRate = ($this, value) => {
var oldValue = $this.VATRate;
$this.VATRate = value;
if (value != null) {
}
}
static setDocuments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Documents == null) $this.Documents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Documents.length > 0) {
                    Domain.AssetTransaction.removeDocuments($this, $this.Documents[0]);
                }

                Domain.AssetTransaction.addManyDocuments($this, copyItems);
            }
static addManyDocuments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetTransaction.addDocuments($this, items[i]);
                }
            }
static addDocuments = ($this, item) => {
                if ($this.Documents == null) $this.Documents = [];
                if (item == null || $this.Documents.indexOf(item) > -1) return;
                $this.Documents.push(item);
}
static addRangeDocuments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetTransaction.addDocuments($this, item));
            }
static removeDocuments = ($this, item) => {
                if ($this == null || $this.Documents == null || $this.Documents.indexOf(item) === -1) return;
                var _index = $this.Documents.indexOf(item);
                $this.Documents.splice(_index, 1);
}
static clearDocuments = ($this) => { $this.Documents = null; }
static setAsset = ($this, value) => {
var oldValue = $this.Asset;
$this.Asset = value;
if (value != null) {
}
}
static setDestructionProtocol = ($this, value) => {
var oldValue = $this.DestructionProtocol;
$this.DestructionProtocol = value;
if (value != null) {
}
}
static setParentAsset = ($this, value) => {
var oldValue = $this.ParentAsset;
$this.ParentAsset = value;
if (value != null) {
}
}
static setExpropriationDocument = ($this, value) => {
var oldValue = $this.ExpropriationDocument;
$this.ExpropriationDocument = value;
if (value != null) {
}
}
static setSubsidyEntities = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubsidyEntities == null) $this.SubsidyEntities = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubsidyEntities.length > 0) {
                    Domain.AssetTransaction.removeSubsidyEntities($this, $this.SubsidyEntities[0]);
                }

                Domain.AssetTransaction.addManySubsidyEntities($this, copyItems);
            }
static addManySubsidyEntities = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetTransaction.addSubsidyEntities($this, items[i]);
                }
            }
static addSubsidyEntities = ($this, item) => {
                if ($this.SubsidyEntities == null) $this.SubsidyEntities = [];
                if (item == null || $this.SubsidyEntities.indexOf(item) > -1) return;
                $this.SubsidyEntities.push(item);
}
static addRangeSubsidyEntities = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetTransaction.addSubsidyEntities($this, item));
            }
static removeSubsidyEntities = ($this, item) => {
                if ($this == null || $this.SubsidyEntities == null || $this.SubsidyEntities.indexOf(item) === -1) return;
                var _index = $this.SubsidyEntities.indexOf(item);
                $this.SubsidyEntities.splice(_index, 1);
}
static clearSubsidyEntities = ($this) => { $this.SubsidyEntities = null; }
static setGeneralJournals = ($this, items) => {
                if (items == null) items = [];
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GeneralJournals.length > 0) {
                    Domain.AssetTransaction.removeGeneralJournals($this, $this.GeneralJournals[0]);
                }

                Domain.AssetTransaction.addManyGeneralJournals($this, copyItems);
            }
static addManyGeneralJournals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetTransaction.addGeneralJournals($this, items[i]);
                }
            }
static addGeneralJournals = ($this, item) => {
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];
                if (item == null || $this.GeneralJournals.indexOf(item) > -1) return;
                $this.GeneralJournals.push(item);
}
static addRangeGeneralJournals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetTransaction.addGeneralJournals($this, item));
            }
static removeGeneralJournals = ($this, item) => {
                if ($this == null || $this.GeneralJournals == null || $this.GeneralJournals.indexOf(item) === -1) return;
                var _index = $this.GeneralJournals.indexOf(item);
                $this.GeneralJournals.splice(_index, 1);
}
static clearGeneralJournals = ($this) => { $this.GeneralJournals = null; }
static setRelatedTransaction = ($this, value) => {
var oldValue = $this.RelatedTransaction;
$this.RelatedTransaction = value;
if (value != null) {
}
}
static setAcquisitionDepartment = ($this, value) => {
var oldValue = $this.AcquisitionDepartment;
$this.AcquisitionDepartment = value;
if (value != null) {
}
}
static setTradingLocation = ($this, value) => {
var oldValue = $this.TradingLocation;
$this.TradingLocation = value;
if (value != null) {
}
}

static GetClassName(): any{return "AssetTransaction";
}
static InvoiceSum($this: any, useNetValueForAssetsTransactions: any): any{return (useNetValueForAssetsTransactions ? $this?.Documents?.linq?.sum((y) => y?.InvoiceDetails?.linq?.sum((x) => x?.NetValue)) : $this?.Documents?.linq?.sum((y) => y?.InvoiceDetails?.linq?.sum((x) => x?.GrossValue)));
}
static ValidateBeforeFinalize($this: any): any{}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}